import React, { Component, Fragment } from 'react';
import { render } from 'react-dom';
import axios from 'axios';
import jsLang from '../lib/jslang';
import iconStar from '../../svg/star-full.svg';
import iconStarHalf from '../../svg/star-half.svg';
import iconStarEmpty from '../../svg/star-empty.svg';

class SubmissionFigureAjax extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            selectedTimePeriod: null,
            timePeriods: [
                '7days',
                '30days',
                'currentQuarter',
                'previousQuarter',
                'allTime',
            ],
            data: null,
        };

        this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    }

    async componentDidMount() {
        const {
            timePeriods,
            selectedTimePeriod,
        } = this.state;

        if (!selectedTimePeriod) {
            this.setState({
                selectedTimePeriod: timePeriods[0],
            });
        }

        try {
            const response = await axios.get('/submission-figures.json');

            this.setState({
                error: null,
                data: response.data.data.submissionFigures,
            });
        } catch (error) {
            this.setState({
                error,
            });
        }
    }

    handleDateRangeChange(event) {
        this.setState({
            selectedTimePeriod: event.target.value,
        });
    }

    renderStarRating() {
        const {
            data,
            selectedTimePeriod,
        } = this.state;

        const stars = [];

        for (let i = 1; i <= 5; i += 1) {
            if (i <= data[selectedTimePeriod].customerSat) {
                stars.push(<img key={ i } className="inline-block" src={ iconStar } alt="Star" />);
            } else {
                stars.push(<img key={ i } className="inline-block" src={ iconStarEmpty } alt="Star (empty)" />);
            }

            if (i === Math.floor(data[selectedTimePeriod].customerSat) && (data[selectedTimePeriod].customerSat - i) >= 0.5) {
                stars.push(<img key={ `${i}-half` } className="inline-block" src={ iconStarHalf } alt="Star (half)" />);

                i += 1;
            }
        }

        return (
            <Fragment>{ stars }</Fragment>
        );
    }

    render() {
        const {
            data,
            error,
            timePeriods,
            selectedTimePeriod,
        } = this.state;

        if (!data) {
            return (
                <Fragment>{ jsLang.get('common.loading') }</Fragment>
            );
        }

        if (error) {
            return (
                <Fragment>{ jsLang.get('dashboard.error') }</Fragment>
            );
        }

        return (
            <Fragment>
                <form className="m-b-lg">
                    <div className="form__group">
                        <label htmlFor="timePeriod" className="inline-block bold m-r-xs">{ jsLang.get('dashboard.dateRange') }</label>

                        <div className="inline-block select width-auto">
                            <select className="form__control" name="timePeriod" id="timePeriod" onChange={ this.handleDateRangeChange }>
                                { timePeriods.map(timePeriod => (
                                    <option key={ timePeriod } value={ timePeriod }>{ jsLang.get(`dashboard.dateRanges.${timePeriod}`) }</option>
                                )) }
                            </select>
                        </div>
                    </div>
                </form>

                <div className="grid grid--gutter-xs">
                    <div className="grid__col grid__col-12">
                        <div className="grid grid--gutter-xs grid--h-gutter-none cards-same-height">
                            <div className="grid__col grid__col-12 grid__col-md-4">
                                <div className="card br-a-none bs-a-none b-r-none-md">
                                    <h2 className="h4">{ jsLang.get('dashboard.leadsAdded.title') }</h2>

                                    <div className="font-size-xl colour-primary bold">
                                        { data[selectedTimePeriod].leadsAdded }
                                    </div>
                                </div>
                            </div>

                            <div className="grid__col grid__col-12 grid__col-md-4">
                                <div className="card br-a-none bs-a-none b-r-none-md">
                                    <h2 className="h4">{ jsLang.get('dashboard.jobsScheduled.title') }</h2>

                                    <div className="font-size-xl colour-primary bold">
                                        { data[selectedTimePeriod].installsScheduled }
                                    </div>
                                </div>
                            </div>

                            <div className="grid__col grid__col-12 grid__col-md-4">
                                <div className="card br-a-none bs-a-none">
                                    <h2 className="h4">{ jsLang.get('dashboard.jobsInstalled.title') }</h2>

                                    <div className="font-size-xl colour-primary bold">
                                        { data[selectedTimePeriod].installsCompleted }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid__col grid__col-12">
                        <div className="grid grid--gutter-xs">
                            <div className="grid__col grid__col-12">
                                <div className="card br-a-none bs-a-none">
                                    <h3>{ jsLang.get('dashboard.customerSat.title') }</h3>

                                    <div className="font-size-xl colour-primary bold inline-block">
                                        { data[selectedTimePeriod].customerSat }
                                    </div>

                                    <div className="m-l-lg inline-block">
                                        { this.renderStarRating() }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const element = document.getElementById('submission-placeholder');

if (element) {
    render(<SubmissionFigureAjax />, element);
}
